const {
  appendPath
} = require('@truqc/content-path');
const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate performBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const contentPath = await evaluateSource(source.contentPath, content, parentContentPath, transientContext, nativeFunctions);
  const newParentContentPath = appendPath(parentContentPath, contentPath);
  return evaluateSource(source.actions, content, newParentContentPath, transientContext, nativeFunctions);
};
module.exports = {
  evaluate
};